import EventEmitter from 'events';
import GenericApolloLink from './GenericApolloLink';

export const loggedOutEvent = 'loggedOut';

const isUnauthorizedError = error =>
  error.statusCode === 401 ||
  (error.message &&
    (error.message.includes('You are not authorized to access this data') ||
      error.message.includes('You must be logged in to execute this query')));

const handleErrors = (errors, onDetectLoggedOut) => {
  const isUnauthorized = errors && !!errors.find(isUnauthorizedError);

  if (isUnauthorized) {
    onDetectLoggedOut();

    return errors.map(error => {
      const updatedError = {...error};
      if (isUnauthorizedError(error)) {
        updatedError.skipReporting = true;
      }
      return updatedError;
    });
  }

  return errors;
};

const generateLinkSubscription = (loggedOutEmitter, observer) => {
  const onDetectLoggedOut = () => {
    loggedOutEmitter.emit(loggedOutEvent);
  };

  return {
    next: result => {
      const {errors} = result;
      let handledErrors;

      if (errors) {
        handledErrors = handleErrors(errors, onDetectLoggedOut);
      }

      observer.next({
        ...result,
        errors: handledErrors,
      });
    },
    error: error => {
      handleErrors([error], onDetectLoggedOut);
      observer.error(error);
    },
    complete: observer.complete.bind(observer),
  };
};

const generateApolloLink = loggedOutEmitter =>
  GenericApolloLink(({observer}) => generateLinkSubscription(loggedOutEmitter, observer));

const generateLoggedOutListener = loggedOutEmitter => callback => {
  loggedOutEmitter.once(loggedOutEvent, callback);
};

export default () => {
  const loggedOutEmitter = new EventEmitter();
  const apolloLink = generateApolloLink(loggedOutEmitter);
  const loggedOutListener = generateLoggedOutListener(loggedOutEmitter);

  return {
    apolloLink,
    loggedOutListener,
  };
};
